<div class="cdsid" routerLink="/home-page">
	<img src="../../../../../../../assets/image/WingsOval.png" class="image-profile"
         onerror="this.src='/assets/image/no_avatar.png'" alt=""/>
	<div class="cdsid__name">
		<span>{{user_name}}</span>
	</div>
</div>
